export default __webpack_public_path__ + "static/media/netflix2.e71c74e2.jpeg";